import axios from "axios";
import { Album } from "../interfaces/album.interface";

class AlbumsApi {

  getAlbums(): Promise<Album[]> {
    const apiUrl = "/api/v1/albums";

    return axios.get(apiUrl)
    .then(response => {
      const albums = response.data.data.map(albumData => {
        const album:Album = {
          id: albumData.attributes.id,
          name: albumData.attributes.name,
          cover: albumData.attributes.cover?.url,
          photos: albumData.attributes.photos,
        }
        return album;
      })
      return Promise.resolve(albums);
    });
  }


  getAlbum(blogId:number): Promise<Album> {
    const apiUrl = `/api/v1/albums/${blogId}`;

    return axios.get(apiUrl)
    .then(response => {
      const albumData = response.data.data.attributes;
      const album:Album = {
        id: response.data.data.id,
        name: albumData.name,
        cover: albumData.cover?.url,
        photos: albumData.photos,
      }
      return Promise.resolve(album);
    });
  }

}

export default AlbumsApi;